import React from 'react';
import { useTranslation } from 'react-i18next';
import { Spinner } from './_new/Spinner';

type PageLoadingProps = {
	text?: string;
};

export const PageLoading = ({ text }: PageLoadingProps) => {
	const { t } = useTranslation();
	return (
		<div className="h-full w-full flex flex-1 justify-content-center align-items-center">
			<div className="flex flex-column gap-2 align-items-center text-center">
				<Spinner size="lg" />
				<div className="text-lg">{text || t('misc.loading')}</div>
			</div>
		</div>
	);
};
